// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-keyboard.hg-theme-default .hg-button.hg-functionBtn {
  background-color: #d6d6da
}
.hg-button.hg-button-enter {
  font-size: 23px;
}
`, "",{"version":3,"sources":["webpack://./web/styles.css"],"names":[],"mappings":"AAAA;EACE;AACF;AACA;EACE,eAAe;AACjB","sourcesContent":[".simple-keyboard.hg-theme-default .hg-button.hg-functionBtn {\n  background-color: #d6d6da\n}\n.hg-button.hg-button-enter {\n  font-size: 23px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
